<template>
  <div class="apvrule">
    <p class="ruleTitle">合同审批制度</p>
    <div v-html="ruleDetail"></div>
  </div>
</template>

<script>
import {
  getRuleDetailService //查询通知公告详情
} from "@/services/sysSettingService";
export default {
  name: "ApproveRule",

  data() {
    return {
      ruleDetail: ""
    };
  },

  methods: {
    //激活时调用
    onActive(menuCode) {
      this.getRuleDetail();
    },
    //获取立项审批制度
    getRuleDetail() {
      let businessType = "0002";
      getRuleDetailService(businessType)
        .then(res => {
          if (res.code == 10000000) {
            this.ruleDetail = res.data.typeExplain;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.apvrule {
  width: 1200px;
  margin: 20px 60px;
  text-align: left;

  font-size: 16px;
  .ruleTitle {
    font-size: 20px;
    text-align: center;
    font-weight: 600;
  }
}
</style>